import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
};

const sectorsReducer = createReducer(initialState, {
  SECTORS_REQ: (state) => {
    state.loading = true;
    state.data = null;
  },
  SECTORS_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
  },
  SECTORS_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
  },
});

export default sectorsReducer;
